import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CONSTANTS} from "../constants/constants";
import {iif, map} from "rxjs";
import {OrderSummary} from "./event-registration.service";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private http: HttpClient) {}

  getPaymentMethods() {
    return this.http.get(`${CONSTANTS.BASE_PAYMENT_API}payment_methods/?brand_id=${CONSTANTS.PAYMENT_BRAND_ID}&currency=${CONSTANTS.DEFAULT_CURRENCY}&country=${CONSTANTS.COUNTRY}`)
  }

  makePayment(orderSummary: OrderSummary, email: string) {
    const origin = window.location.origin;
    return this.http.post(`${CONSTANTS.BASE_PAYMENT_API}purchases/?brand_id=${CONSTANTS.PAYMENT_BRAND_ID}&currency=${CONSTANTS.DEFAULT_CURRENCY}&country=${CONSTANTS.COUNTRY}`, {
      brand_id: CONSTANTS.PAYMENT_BRAND_ID,
      success_redirect: `${origin}/event-registration/24/success?reference_id=${1111}`,
      failure_redirect: `${origin}/event-registration/24/fail`,
      cancel_redirect: `${origin}/event-registration/24/form`,
      purchase: {
        language: "lv",
        products: [
          {
            price: orderSummary.price * 100,
            name: orderSummary.name
          },
          {
            price: orderSummary.commission * 100,
            name: 'Commission fee'
          }
        ],
      },
      client: {
        email: email
      },
      reference: 1111
    })
  }
}
